/**
 * @generated SignedSource<<5a360eca08cb8d8d53c43f8edf7051a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskFragmentType$data = {
  readonly typeItem: {
    readonly id: string | null | undefined;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"ItemFragment">;
  } | null | undefined;
  readonly " $fragmentType": "TaskFragmentType";
};
export type TaskFragmentType$key = {
  readonly " $data"?: TaskFragmentType$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskFragmentType">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskFragmentType",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ListItem",
      "kind": "LinkedField",
      "name": "typeItem",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ItemFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};

(node as any).hash = "ec452b91fc522291f300eb409d201f1a";

export default node;
